import { useEffect } from 'react';
import { shallowEqual } from 'react-redux';

import { useProfileContext } from '@/features/context/ProfileContext';
import { getWallets } from '@/features/wallets/store/actions/wallet.actions';

import { useAppSelector, useAppDispatch } from '@/hooks/redux-helpers';

import { selectProfileWalletsByUserId, selectWalletsByUserId } from '@/store/selectors';

export function useUserWalletList() {
  const { user } = useProfileContext();
  const dispatch = useAppDispatch();

  const isLoading = useAppSelector((state) => selectProfileWalletsByUserId(state, user.userId)?.isLoading);
  const wallets = useAppSelector((state) => selectWalletsByUserId(state, user.userId), shallowEqual) || [];

  useEffect(() => {
    dispatch(getWallets(user.userId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.userId]);

  return { isLoading, wallets };
}
